import Forms from "../forms/Forms";
import Nps from "../nps/Nps";
export var AppRoutes = {
    "/nps/:slug": Nps,
    "/forms/:slug": Forms,
};
